import { render } from "./InvoicesDashboard.vue?vue&type=template&id=7b06b87e"
import script from "./InvoicesDashboard.vue?vue&type=script&lang=js"
export * from "./InvoicesDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/src/Hikarusa.Webapp/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__